import { Button, styled } from "@mui/material";

export const CustomButtonWithCheckboxRoot = styled(Button)(() => ({
	fontFamily: "inherit",
	fontSize: 11,
	fontStyle: "inherit",
	fontWeight: "inherit",
	lineHeight: "inherit",
	letterSpacing: "inherit",
	overflow: "hidden",
	// width: "100%",
	// display: "flex",
	// alignItems: "center",
	// whiteSpace: "nowrap",
	// textWrap: "nowrap",
	// textOverflow: "ellipsis",
}));
